import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { pages } from './pages';
import ScrollToTop from './components/ScrollToTop';
import { ThemeProvider } from './contexts/ThemeContext';
import './assets/FontAwesomeLibrary';

function App() {
  return (
    <ThemeProvider>
      <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {pages.map((page, index) => (
            <Route key={index} path={page.path} element={page.element} />
          ))}
        </Routes>
      </BrowserRouter>
      </HelmetProvider>
    </ThemeProvider>
  );
}

export default App;
